import { JSX, useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import useStorage, { StorageEntry } from "lib/storage/useStorage";
import { asTitle } from "./Utils";

const cookiesEntry: StorageEntry = {
	key: "cookies"
};

export default function CookieBanner(): JSX.Element {
	const { t } = useTranslation();

	const acceptedCookies = useStorage(cookiesEntry);

	const confirmCookies = useCallback((): void => {
		acceptedCookies.set("true");
	}, []);

	if (acceptedCookies.value === "true") {
		return <></>;
	}

	return (
		<Paper
			elevation={1}
			tabIndex={-1}
			sx={{
				position: "fixed",
				bottom: 0,
				left: 0,
				right: 0,
				margin: 2,
				padding: 2,
				backgroundColor: "grey.50"
			}}>
			<Stack
				direction={{ xs: "column", sm: "row" }}
				justifyContent="space-between"
				gap={2}>
				<Box>
					<Typography variant="h6">
						{asTitle(t("cookiesTitle"))}
					</Typography>
					<Typography variant="body2" aria-label="cookies-message">
						{t("cookiesMessage")}
					</Typography>
					<Typography variant="body2" aria-label="cookies-link">
						<Trans
							i18nKey="cookiesLink"
							components={{
								privacyLink: (
									<a
										target="_blank"
										href="https://www.trajectx.com/privacy">
										link
									</a>
								)
							}}
						/>
					</Typography>
				</Box>
				<Stack
					gap={2}
					direction={{
						xs: "row-reverse",
						sm: "row"
					}}
					sx={{
						flexShrink: 0,
						alignSelf: "flex-end"
					}}>
					<Button
						size="small"
						variant="contained"
						onClick={confirmCookies}>
						{t("ok")}
					</Button>
				</Stack>
			</Stack>
		</Paper>
	);
}
